import { render, staticRenderFns } from "./OAApprove.vue?vue&type=template&id=3d0d70c4&scoped=true"
import script from "./OAApprove.vue?vue&type=script&lang=js"
export * from "./OAApprove.vue?vue&type=script&lang=js"
import style0 from "./OAApprove.vue?vue&type=style&index=0&id=3d0d70c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d70c4",
  null
  
)

export default component.exports